module.exports = __webpack_public_path__ + "img/product_116.aaea6ca.webp";